import { NgModule } from '@angular/core';
import { RadioComponent } from './radio/radio';
import { IonicModule } from 'ionic-angular';
import { BotaoFacebookComponent } from './botao-facebook/botao-facebook';
import { BotaoTwitterComponent } from './botao-twitter/botao-twitter';
import { BlocoBotoesRedeSocialComponent } from './bloco-botoes-rede-social/bloco-botoes-rede-social';
import { MenuGeralComponent } from './menu-geral/menu-geral';
import { InputMensagemComponent } from './input-mensagem/input-mensagem';
import { AutosizeModule } from 'ngx-autosize';
import { AtalhoComponent } from './atalho/atalho';
import { ConversaUsuarioComponent } from './conversa-usuario/conversa-usuario';
import { ConversaAreaComponent } from './conversa-area/conversa-area';
import { ConversaAreaAdminComponent } from './conversa-area-admin/conversa-area-admin';
import { ConversaAreaGeralComponent } from './conversa-area-geral/conversa-area-geral';
import { ConversaAreaUsuarioComponent } from './conversa-area-usuario/conversa-area-usuario';
import { MenuPopoverComponent } from './menu-popup/menu-popover';

@NgModule({
	declarations: [RadioComponent,
    BotaoFacebookComponent,
    BotaoTwitterComponent,
    BlocoBotoesRedeSocialComponent,
    MenuGeralComponent,
    InputMensagemComponent,
    AtalhoComponent,
    ConversaUsuarioComponent,
    ConversaAreaComponent,
    ConversaAreaAdminComponent,
    ConversaAreaGeralComponent,
    ConversaAreaUsuarioComponent,
    MenuPopoverComponent
    ],
	imports: [IonicModule.forRoot(ComponentsModule), AutosizeModule],
	exports: [RadioComponent,
    BotaoFacebookComponent,
    BotaoTwitterComponent,
    BlocoBotoesRedeSocialComponent,
    MenuGeralComponent,
    InputMensagemComponent,
    AtalhoComponent,
    ConversaUsuarioComponent,
    ConversaAreaComponent,
    ConversaAreaAdminComponent,
    ConversaAreaGeralComponent,
    ConversaAreaUsuarioComponent,
    MenuPopoverComponent
    ],
    entryComponents: [
        MenuPopoverComponent
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts